import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { approveHolidayCancellation, rejectHolidayCancellation } from "./api";
import api from "./api"; // On peut utiliser api pour le GET

function CancelHolidayRequests() {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    async function fetchCancellationRequests() {
      try {
        // Récupérer uniquement les demandes d'annulation
        const response = await api.get(
          "/admin/all-holiday-requests?status=cancel_requested"
        );
        setRequests(response.data);
      } catch (error) {
        toast.error("Failed to fetch cancellation requests");
      }
    }
    fetchCancellationRequests();
  }, []);

  const handleApprove = async (id) => {
    try {
      await approveHolidayCancellation(id);
      toast.success("Cancellation approved");
      setRequests((prev) => prev.filter((req) => req.id !== id));
    } catch (error) {
      toast.error("Failed to approve cancellation");
    }
  };

  const formatDate = (dateString, dayType) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    // Append morning or afternoon based on dayType
    if (dayType === "morning") {
      return `${formattedDate} (Morning)`;
    } else if (dayType === "afternoon") {
      return `${formattedDate} (Afternoon)`;
    }
    return formattedDate; // For full day
  };

  const handleReject = async (id) => {
    try {
      const reason = prompt("Enter reason for rejection:");
      if (reason === null) return;
      await rejectHolidayCancellation(id, reason);
      toast.success("Cancellation rejected");
      setRequests((prev) => prev.filter((req) => req.id !== id));
    } catch (error) {
      toast.error("Failed to reject cancellation");
    }
  };

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Cancellation Requests</h1>
      <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-md">
        <thead>
          <tr>
            <th className="px-4 py-2">User</th>
            <th className="px-4 py-2">Start Date</th>
            <th className="px-4 py-2">End Date</th>
            <th className="px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((req) => (
            <tr key={req.id} className="border-t">
              <td className="px-4 py-2">
                {req.firstName} {req.lastName}
              </td>
              <td className="px-4 py-2">
                {formatDate(req.start_date, req.start_date_type)}
              </td>
              <td className="px-4 py-2">
                {formatDate(req.end_date, req.end_day_type)}
              </td>
              <td className="px-4 py-2">
                <button
                  onClick={() => handleApprove(req.id)}
                  className="bg-green-500 text-white px-4 py-2 rounded mr-2"
                >
                  Approve
                </button>
                <button
                  onClick={() => handleReject(req.id)}
                  className="bg-red-500 text-white px-4 py-2 rounded"
                >
                  Reject
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CancelHolidayRequests;
